// extracted by mini-css-extract-plugin
export default {"container":"Logo_container__unxNW","center_logo":"Logo_center_logo__uXioF","logo":"Logo_logo__cgH4T","white-bg":"Logo_white-bg__-oeP2"};